import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { translate } from 'react-i18next';
import debounce from 'lodash/debounce';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { getUsers, setFilters, setPagination } from 'users/actions';

import { getCompany, getPermissions } from 'auth/selectors';
import {
  getVisibleUsers,
  getFilters,
  getPagination,
  getIsLoading,
  getNeedFetch,
} from 'users/selectors';

import * as Common from 'common/components';
import * as Users from 'users/components';
import UserRowContainer from 'users/containers/UserRowContainer';
import { valueFromEvent } from 'lib/util';
import { toggleUser } from 'users/actions';
import { addGrowlError as error, addGrowlSuccess as success } from 'messages/actions';

class UserListContainer extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };
  state = {
    columnSearch: [
      // Cambiar por redux
      { key: 'name', name: this.props.t('users.searchEditor.name'), search: true },
      { key: 'lastname', name: this.props.t('users.searchEditor.lastName'), search: true },
      { key: 'email', name: this.props.t('users.searchEditor.email'), search: true },
    ],
  };

  handleToggleSearch = (col) => {
    let columnsNuevo = this.state.columnSearch;
    let datos = columnsNuevo.find((column) => column.key == col);
    datos.search = !datos.search;
    this.setState({ columnSearch: columnsNuevo });
    let columnsSearch = [];
    columnsNuevo.forEach((e) => {
      if (e.search) {
        columnsSearch.push(e.key);
      }
    });
    this.props.setFilters({ columnSearch: columnsSearch }); // Agregado a Redux
  };
  componentWillMount = () => this.fetch(this.props.filters, this.props.pagination);

  componentWillReceiveProps = (nextProps) =>
    nextProps.needFetch && this.fetch(nextProps.filters, nextProps.pagination);

  fetch = (filters, pagination) =>
    this.props.getUsers(
      this.props.company.id,
      filters,
      pagination.limit,
      pagination.page,
      pagination.orderBy,
      pagination.order
    );

  fetchDebounced = debounce(this.fetch, 100);

  handleSubmit = () => this.fetch(this.props.filters, this.props.pagination);

  handleValueChange = (e) => this.props.setFilters(valueFromEvent(e));

  handleOrderChange = (orderBy, order) => this.props.setPagination({ orderBy, order });

  handleLimitChange = (limit) => this.props.setPagination({ limit });

  handlePageChange = (page) => this.props.setPagination({ page });

  handleToggle = (id) => {
    console.log(id);
    console.log(this.props.company);

    return this.props
      .toggleUser(this.props.company.id, id)
      .then(({ value }) => this.props.success(value.message))
      .catch((err) => this.props.error(err.message));
  };

  render() {
    const { t, users, pagination, filters } = this.props;

    return (
      <Common.PageWrapper fluid={true}>
        {/* <Users.ListHeader
          companyId={this.props.company.id}
          canAdd={this.props.permissions["acl.roles.add"] || false}
        /> */}
        <div className="col-12">
          <Common.Portlet
            title={t('menu.control_panel') + ' > ' + t('users.subtitle')}
            icon={'users'}
            button={
              // {this.props.permissions["acl.roles.add"] && (
              <div className="btn-group pull-right">
                <Link to={`/companies/${this.props.company.id}/users/add`} className="btn btn-info">
                  {t('actions.add')}
                </Link>
              </div>
              // )}
            }
            buttonTwo={
              <Users.Filters
                handleSubmit={this.handleSubmit}
                handleToggleSearch={this.handleToggleSearch}
                columnSearch={this.state.columnSearch}
                handleValueChange={this.handleValueChange}
                values={filters}
              />
            }
          >
            <Users.Table
              count={users.length}
              order={pagination.order}
              orderBy={pagination.orderBy}
              handleToggle={this.handleToggle}
              company={this.props.company}
              permissions={this.props.permissions}
              isLoading={this.props.isLoading}
              handleOrderChange={this.handleOrderChange}
            >
              {users.map((user) => (
                <UserRowContainer key={user.id} user={user} handleToggle={this.handleToggle} />
              ))}
            </Users.Table>
            <Common.Pagination
              {...pagination}
              handleLimitChange={this.handleLimitChange}
              handlePageChange={this.handlePageChange}
            />
          </Common.Portlet>
        </div>
      </Common.PageWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  filters: getFilters(state),
  isLoading: getIsLoading(state),
  needFetch: getNeedFetch(state),
  pagination: getPagination(state),
  users: getVisibleUsers(state),
  permissions: getPermissions(state),
});

const mapDispatchToProps = {
  getUsers,
  setFilters,
  setPagination,
  toggleUser,
  error,
  success,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate()
)(UserListContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/users/containers/UsersListContainer.js